// service_ids is authoritative, including an explicitly empty selection.
export function getStaffServiceIds(member) {
  if (Array.isArray(member?.service_ids)) return member.service_ids;
  return Array.isArray(member?.services) ? member.services : [];
}

export function bookingStaff(booking, staff, calendars) {
  const id = booking.staff_id || calendars.find(c => c.calendar_id === booking.calendar_id)?.staff_id;
  return id ? staff.find(s => s.staff_id === id) : undefined;
}
